export default __webpack_public_path__ + "fonts/up-arrow-white.svg";